var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataExportCancelDisabledIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.514,
    height: 10.514,
    viewBox: "0 0 10.514 10.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2093",
    "data-name": "Group 2093",
    transform: "rotate(45 7.32 4.403)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_304",
    width: 1.939,
    height: 12.93,
    className: "prefix__cls-1",
    "data-name": "Rectangle 304",
    rx: 0.97,
    transform: "translate(5.495)",
    fill: "#D8DAF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_305",
    width: 1.939,
    height: 12.93,
    className: "prefix__cls-1",
    "data-name": "Rectangle 305",
    rx: 0.97,
    transform: "rotate(90 3.717 9.213)",
    fill: "#D8DAF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataExportCancelDisabledIcon);
export default __webpack_public_path__ + "static/media/DataExportCancelDisabledIcon.64db2358e3fc06767d403daeee560a4e.svg";
export { ForwardRef as ReactComponent };